// Pasos de producción de ECMA-262, Edición 5, 15.4.4.17
// Referencia: http://es5.github.io/#x15.4.4.17
if (!Array.prototype.some) {
  Array.prototype.some = function (fun/*, thisArg*/) {
    'use strict';

    if (this == null) {
      throw new TypeError('Array.prototype.some called on null or undefined');
    }

    if (typeof fun !== 'function') {
      throw new TypeError();
    }

    let t = Object(this);
    let len = t.length >>> 0;

    let thisArg = arguments.length >= 2 ? arguments[1] : void 0;
    for (let i = 0; i < len; i++) {
      if (i in t && fun.call(thisArg, t[i], i, t)) {
        return true;
      }
    }

    return false;
  };
}

formatNumber = function (value, locale, options) {
  let number = 0;
  if (locale === 'en') {
    if (options === undefined) {
      options = {
        minimumFractionDigits: 2
      };
    }
    value = value.replace(/[^-.\d]/g, '');
    number = parseFloat(value);
  } else {
    value = value.replace(/\./g, '').replace(/,/g, '.').replace(/[^-.\d]/g, '');
    number = Math.round(parseFloat(value));
  }

  if (isNaN(number)) {
    number = 0;
  }

  return new Intl.NumberFormat(locale, options).format(number);
};
